import { Box, styled } from '@mui/material'
import { Workflow, WorkflowListItem, ExtendedWorkflow } from 'features/workflows/types'
import WorkflowMcpToolEnabled from '../Editor/WorkflowHeader/WorkflowMcpToolEnabled'
import WorkflowApiEnabled from '../Editor/WorkflowHeader/WorkflowApiEnabled'

interface WorkflowCardBadgesProps {
  workflow: WorkflowListItem | ExtendedWorkflow | Workflow
}

const BadgesContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(1.375),
  left: theme.spacing(1.375),
  display: 'flex',
  flexDirection: 'row',
  zIndex: 1,
  pointerEvents: 'none', // Prevent interference with card hover
  '& > *': {
    pointerEvents: 'auto' // Re-enable pointer events for individual badges
  }
}))

function WorkflowCardBadges({ workflow }: WorkflowCardBadgesProps) {
  return (
    <BadgesContainer>
      <WorkflowMcpToolEnabled workflow={workflow} compact />
      <WorkflowApiEnabled workflow={workflow} compact />
    </BadgesContainer>
  )
}

export default WorkflowCardBadges
